<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <package-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:sidebar>
            <selected-offers
                v-if="loaded"
                :direction="'column'"
                :changable="false"
                :bookable="false"
                :hotel="basketItem.hotel"
                :room="basketItem.room"
                :flight="basketItem.flight"
                :price="basketItem.price"
                :search-request="searchRequest"
                :total-order-price="basketItem.totalPrice"
                :current-price="basketItem.currentPrice"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {mixins, Component} from 'vue-facing-decorator'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import SelectedOffers from '~/components/packages/search/SelectedOffers.vue'
    import PackageBreadcrumbs from '~/components/packages/PackageBreadcrumbs.vue'
    import {PackagePageMixin} from '@/components/packages/mixins/PackagePageMixin.vue'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'

    @Component({
        components: {
            ConfirmationPageLayout,
            ConfirmationStatus,
            PackageBreadcrumbs,
            SelectedOffers,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class PackageConfirmationPage extends mixins(PackagePageMixin, ConfirmationPageMixin) {
        get basketItem() {
            return packagesStore.basketItem(packagesStore.prepareBookRequest.offerKey)
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }
    }

    export default PackageConfirmationPage
</script>
